import { SideNavOptions } from './types';

type AdminOnlyNavType =
  | 'FUNDING_REQUEST_TRACKER'
  | 'REFERRER_SETUP'
  | 'FINANCIAL_REPORTING_DASHBOARD';

const ADMIN_ONLY_NAV_TYPES: AdminOnlyNavType[] = [
  'FUNDING_REQUEST_TRACKER',
  'REFERRER_SETUP',
  'FINANCIAL_REPORTING_DASHBOARD',
];

type ClientOwnerNavType = 'CLIENT_USER_MANAGEMENT';

const CLIENT_OWNER_ONLY_NAV_TYPES: ClientOwnerNavType[] = ['CLIENT_USER_MANAGEMENT'];

export const getSideNavBarOptions = (filteredOptions: SideNavOptions[], isAdmin: boolean) => {
  const manageUsersOptionIndex = filteredOptions.findIndex(
    (option) => option?.subOptions?.[0]?.type === 'CLIENT_USER_MANAGEMENT',
  );
  const manageUsersOption =
    manageUsersOptionIndex >= 0 ? filteredOptions[manageUsersOptionIndex] : undefined;

  if (!isAdmin) {
    const nonAdminDashboardOptions = filteredOptions.filter(
      (option) =>
        !CLIENT_OWNER_ONLY_NAV_TYPES.includes(
          (option?.subOptions?.[0]?.type as ClientOwnerNavType) || '',
        ),
    );
    return {
      dashboardOptions: nonAdminDashboardOptions,
      mobileDashboardOptions: nonAdminDashboardOptions,
      requestTrackerOptionIndex: -1,
      referrerSetupOptionIndex: -1,
      financialReportingOptionIndex: -1,
      requestTrackerOption: undefined,
      referrerSetupOption: undefined,
      financialReportingOption: undefined,
      manageUsersOption,
      manageUsersOptionIndex,
    };
  }

  const dashboardOptions = filteredOptions.filter(
    (option) =>
      ![...ADMIN_ONLY_NAV_TYPES, ...CLIENT_OWNER_ONLY_NAV_TYPES].includes(
        (option?.subOptions?.[0]?.type as AdminOnlyNavType) || '',
      ),
  );

  const mobileDashboardOptions = filteredOptions.filter(
    (option) =>
      !CLIENT_OWNER_ONLY_NAV_TYPES.includes(
        (option?.subOptions?.[0]?.type as ClientOwnerNavType) || '',
      ),
  );

  const requestTrackerOptionIndex = filteredOptions.findIndex(
    (option) => option?.subOptions?.[0]?.type === 'FUNDING_REQUEST_TRACKER',
  );

  const referrerSetupOptionIndex = filteredOptions.findIndex(
    (option) => option?.subOptions?.[0]?.type === 'REFERRER_SETUP',
  );
  const financialReportingOptionIndex = filteredOptions.findIndex(
    (option) => option?.subOptions?.[0]?.type === 'FINANCIAL_REPORTING_DASHBOARD',
  );

  const requestTrackerOption =
    requestTrackerOptionIndex >= 0 ? filteredOptions[requestTrackerOptionIndex] : undefined;
  const referrerSetupOption =
    referrerSetupOptionIndex >= 0 ? filteredOptions[referrerSetupOptionIndex] : undefined;
  const financialReportingOption =
    financialReportingOptionIndex >= 0 ? filteredOptions[financialReportingOptionIndex] : undefined;

  return {
    dashboardOptions,
    mobileDashboardOptions,
    requestTrackerOptionIndex,
    referrerSetupOptionIndex,
    financialReportingOptionIndex,
    requestTrackerOption,
    referrerSetupOption,
    financialReportingOption,
    manageUsersOption,
    manageUsersOptionIndex,
  };
};
